// @refresh reload
import "solid-devtools/setup";

import Log from "@repo/utils/Log";
import Env from "@repo/utils-client/Env";
import Platform from "@repo/utils-client/Platform";

if (
  Platform.isClient &&
  new URLSearchParams(window.location.search).has("DEBUG")
)
  Log.config.level = "debug";
Env.config.debug =
  import.meta.env.APP_ENV !== "production" || Log.config.level === "debug";
Log.config.enabled = Env.config.debug;

import { onCleanup, onMount, Suspense } from "solid-js";
import { MetaProvider, Title } from "@solidjs/meta";
import { Router } from "@solidjs/router";
import { FileRoutes } from "@solidjs/start/router";

import Api from "@repo/api";
import { useError } from "@repo/ui/error/ErrorProvider";
import GoogleSignIn from "@repo/ui/external/GoogleSignIn";
import GlobalRoot from "@repo/ui/global/GlobalRoot";
import Constraints from "@repo/ui/layout/Constraints";
import UString from "@repo/utils/UString";
import AppRouter from "@repo/utils-solid/AppRouter";

import { useAdmin } from "./state/features/admin";
import { OverlaysProvider, useOverlaysBase } from "./overlays";

export default function App() {
  return (
    <Router
      root={(props) => {
        AppRouter.register();

        return (
          <GoogleSignIn.Provider
            clientId={import.meta.env.ADMIN_GOOGLE_OAUTH_CLIENT_ID}
            apiDomain={UString.afterPrefix(
              new URL(Api.origin).hostname,
              "api."
            )}
          >
            <Constraints.PropsProvider maxWidth="1000px">
              <MetaProvider>
                <Title>Admin | Kikoff</Title>
                <GlobalRoot OverlaysProvider={OverlaysProvider}>
                  {(() => {
                    const [, setAdmin] = useAdmin();
                    const error = useError();
                    const overlaysBase = useOverlaysBase();

                    onCleanup(
                      GoogleSignIn.Callback.add(({ credential }) => {
                        setAdmin.googleSsoCallback(credential).catch((e) => {
                          error.capture(e);
                        });
                      }).remove
                    );

                    onMount(() => {
                      setAdmin.fetch().catch((e) => {
                        error.capture(e.message);
                      });
                    });

                    return (
                      <Suspense>
                        {props.children}
                        {overlaysBase.render()}
                      </Suspense>
                    );
                  })()}
                </GlobalRoot>
              </MetaProvider>
            </Constraints.PropsProvider>
          </GoogleSignIn.Provider>
        );
      }}
    >
      <FileRoutes />
    </Router>
  );
}
